// src/components/CalculationDetails.js
import React from 'react';
import { Link, useParams } from 'react-router-dom';

const CalculationDetails = () => {
    const { type } = useParams();

    const details = {
        stackreport: {
            title: 'Stack Analysis',
            description: 'This calculation adds up the values you provide.',
        },
        // subtract: {
        //     title: 'Subtraction',
        //     description: 'This calculation subtracts the values you provide.',
        // },
        // Add more details for other types
    };

    return (
        <div className="h-screen flex items-center justify-center bg-light-brown text-dark-gray">
            <div className="max-w-2xl mx-auto p-8">
                <h2 className="text-4xl font-bold text-center mb-4">{details[type].title}</h2>
                <p className="text-lg text-center mb-4">{details[type].description}</p>
                <div className="text-center">
                    <Link to={`/user-info/${type}`} className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded">
                        Next
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default CalculationDetails;